import React from "react";
import { useParams } from "react-router-dom";
import mockMac from "./mockMac";
import "./MacDetail.scss";

const MacDetail = () => {
  const { id } = useParams();

  const product = mockMac.find((p) => p.id === parseInt(id));

  return (
    <div className="MacDetail">
      <div className="MacDetail-card">
        <div className="MacDetail-card_imgs">
          <img
            className="MacDetail-card_imgs--img"
            src={`${process.env.PUBLIC_URL}/${product.img2}`}
          />
          <img
            className="MacDetail-card_imgs--img"
            src={`${process.env.PUBLIC_URL}/${product.img}`}
          />
          <img
            className="MacDetail-card_imgs--img"
            src={`${process.env.PUBLIC_URL}/${product.img3}`}
          />
        </div>
        <h2 className="MacDetail-card_model">{product.model}</h2>
        <p className="MacDetail-card_propertis">{product.propertisA}</p>
        <p className="MacDetail-card_propertis">{product.propertis1}</p>
        <p className="MacDetail-card_propertis">{product.propertis2}</p>
        <p className="MacDetail-card_propertis">{product.propertis3}</p>
        <p className="MacDetail-card_propertis">{product.propertis4}</p>
        <p className="MacDetail-card_propertis">{product.propertis5}</p>
      </div>
      <div className="MacDetail-colors">
        <img
          className="MacDetail-colors_img"
          src={`${process.env.PUBLIC_URL}/${product.colors}`}
        />
      </div>
    </div>
  );
};

export default MacDetail;
